<template>
  <LoginWrapper>
    <LoginLogo />
    <LoginForm v-if="!showPasswordReset" @show-password-reset="showPasswordReset = true" />
    <PasswordResetForm v-else @back-to-login="showPasswordReset = false" />
  </LoginWrapper>
</template>

<script>
import LoginWrapper from "@components/login/LoginWrapper.vue";
import LoginLogo from "@components/login/LoginLogo.vue";
import LoginForm from "@components/login/LoginForm.vue";
import PasswordResetForm from "@components/login/PasswordResetForm.vue";

export default {
  components: {
    LoginWrapper,
    LoginForm,
    LoginLogo,
    PasswordResetForm,
  },
  data() {
    return {
      showPasswordReset: false,
    };
  },
};
</script>

<style lang="scss" src="~/components/login/index.scss" />
